import { useContext } from "react";
import AuthorisationContext from "../contexts/AuthorisationContext";

const useAuthorisation = () => {
  return useContext(AuthorisationContext);
};

export const useBulkOrderMode = () => {
  const { authorisation } = useContext(AuthorisationContext);
  return authorisation?.roles?.allowBulkOrder === true;
};

export default useAuthorisation;
